import { html } from "uhtml";
import { Customised } from "../custom-element.js";
import { signal } from "alien-signals";

export function showToast(text) {
  document.querySelector("cassis-toast")?.pop(text);
}

export class CassisToast extends Customised(HTMLElement) {
  static tagName = "cassis-toast";
  text = signal("");
  pop(text) {
    this.text(text);
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("popover", "auto");
    this.hidePopover();
  }
  updated() {
    if (this.text()) {
      this.showPopover();
      setTimeout(() => {
        this.hidePopover();
      }, 5000);
    }
  }
  signals() {
    return {
      text: this.text(),
    };
  }
  render({ text }) {
    return html`<span>${text}</span>`;
  }
}
CassisToast.define();
